import type { Getter, Setter } from 'jotai';
import type { UndoRedoActionCommand } from '../../../../../modernization-common/undo-redo/types';
import type { DeleteEdgePayload, TemplateEdgeT } from '../../../types/skeleton-template-builder.type';
import { templateEdgesAtom } from '../template-atoms';
export const deleteEdgeCommandFactory = (get: Getter, set: Setter): UndoRedoActionCommand<DeleteEdgePayload, void> => {
  let deletedEdge: TemplateEdgeT | undefined;
  return {
    execute: payload => {
      const {
        sourceNodeId,
        targetNodeId
      } = payload;
      const edges = get(templateEdgesAtom);
      deletedEdge = edges.find(e => e.sourceNodeId === sourceNodeId && e.targetNodeId === targetNodeId);
      if (!deletedEdge) return;
      set(templateEdgesAtom, edges.filter(e => !(e.sourceNodeId === sourceNodeId && e.targetNodeId === targetNodeId)));
    },
    undo: () => {
      if (!deletedEdge) return;
      set(templateEdgesAtom, [...get(templateEdgesAtom), deletedEdge]);
    }
  };
};